import { usePWAContext } from "./PWAProvider";
import { MdNotifications, MdNotificationsOff } from "react-icons/md";

const NotificationSettings = () => {
  const { notificationsEnabled, enableNotifications } = usePWAContext();

  return (
    <div className="flex items-center justify-between p-4 bg-white rounded-xl shadow">
      <div className="flex items-center gap-3">
        {notificationsEnabled ? (
          <MdNotifications size={24} className="text-blue-500" />
        ) : (
          <MdNotificationsOff size={24} className="text-gray-400" />
        )}
        <div>
          <p className="text-sm font-medium text-gray-800">
            Push Notifications
          </p>
          <p className="text-xs text-gray-500">
            {notificationsEnabled
              ? "You will receive alerts when devices go offline"
              : "Enable to receive real-time network alerts"}
          </p>
        </div>
      </div>

      <button
        onClick={enableNotifications}
        disabled={notificationsEnabled}
        className={`px-3 py-1.5 rounded-lg text-xs font-medium transition ${
          notificationsEnabled
            ? "bg-green-100 text-green-700 cursor-default"
            : "bg-blue-600 text-white hover:bg-blue-700"
        }`}
      >
        {notificationsEnabled ? "Enabled ✓" : "Enable"}
      </button>
    </div>
  );
};

export default NotificationSettings;